import React from "react";
import { useTranslation } from 'react-i18next';
import dayjs from "dayjs";
import { FiUsers } from "react-icons/fi";
import { PiDog } from "react-icons/pi";
import "../../../../styles/TrainingDetailsModal.css";

const GroupTrainingDetailsModal = ({ isOpen, onClose, training, onGoToGroup }) => {
    const { t } = useTranslation(['calendar', 'common']);

    if (!isOpen || !training) return null;

    const startTime = dayjs(training.startTime || training.scheduledAt);
    const endTime = dayjs(training.endTime);
    const duration = endTime.diff(startTime, 'minute');

    const handleOverlayClick = (e) => {
        if (e.target.classList.contains('tdm-overlay')) {
            onClose();
        }
    };

    const handleGoToGroup = () => {
        const groupId = training.groupId;
        if (groupId) {
            onClose();
            window.location.hash = `#/trainer/group/${groupId}`;
        }
    };

    const dogCount = training.participatingDogCount ?? 0;
    const trainerCount = training.participatingTrainerCount ?? 0;

    return (
        <div className="tdm-overlay" onClick={handleOverlayClick}>
            <div className="tdm-modal">
                {/* Header */}
                <div className="tdm-header">
                    <h2 className="tdm-title">{training.groupName || t('groupTraining')}</h2>
                    <p className="tdm-subtitle">
                        {startTime.format('DD.MM.YYYY')} • {startTime.format('HH:mm')} - {endTime.format('HH:mm')}
                    </p>
                    <button className="tdm-close-btn" onClick={onClose}>✕</button>
                </div>

                {/* Content */}
                <div className="tdm-content">
                    {/* Training Information */}
                    <div className="tdm-section">
                        <h3 className="tdm-section-title">{t('groupDetails.trainingInfo')}</h3>
                        <div className="tdm-info-grid">
                            <div className="tdm-info-item">
                                <span className="tdm-label">{t('details.duration')}</span>
                                <span className="tdm-value">{t('details.durationMinutes', { minutes: duration })}</span>
                            </div>
                            {training.hallName && (
                                <div className="tdm-info-item">
                                    <span className="tdm-label">{t('details.hall')}</span>
                                    <span className="tdm-value">{training.hallName}</span>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Group Stats */}
                    <div className="tdm-section">
                        <h3 className="tdm-section-title">{t('groupDetails.participants')}</h3>
                        <div className="tdm-info-grid">
                            <div className="tdm-info-item">
                                <span className="tdm-label">
                                    <PiDog style={{ verticalAlign: 'middle', marginRight: '6px' }} />
                                    {t('groupDetails.dogs')}
                                </span>
                                <span className="tdm-value">{dogCount}</span>
                            </div>
                            <div className="tdm-info-item">
                                <span className="tdm-label">
                                    <FiUsers style={{ verticalAlign: 'middle', marginRight: '6px' }} />
                                    {t('groupDetails.trainers')}
                                </span>
                                <span className="tdm-value">{trainerCount}</span>
                            </div>
                        </div>
                    </div>

                    {/* Notes */}
                    {training.notes && (
                        <div className="tdm-section">
                            <h3 className="tdm-section-title">{t('groupDetails.notes')}</h3>
                            <div className="tdm-additional-info">
                                {training.notes}
                            </div>
                        </div>
                    )}
                </div>

                {/* Footer */}
                <div className="tdm-footer">
                    <button
                        className="tdm-edit-btn"
                        onClick={handleGoToGroup}
                    >
                        {t('groupDetails.goToGroup')}
                    </button>
                    <button
                        className="tdm-delete-btn"
                        onClick={onClose}
                    >
                        {t('common:close')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default GroupTrainingDetailsModal;
